<template>
  <div class="havingMoneyShow">
    <p class="congratulationsTip">恭喜您通过银行初审，获得预授信额度</p>
    <div class="money"><span>{{this.$store.state.commonForms.bwAmount}}</span><span>元</span></div>
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'HavingMoneyShow',
  mounted() {
  },
};
</script>
<style scoped>
.havingMoneyShow {
    box-sizing: border-box;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
}
.congratulationsTip {
color: #1C2438;
    font-size: 14px;
letter-spacing: 0;
text-align: center;
}
.money {
    width: 100%;
    font-size: 25px;
    text-align: center;
}
.smallTip {
color: #9EA7B4;
    font-size: 12px;
letter-spacing: 0;
text-align: center;
}
</style>
